import styled from 'styled-components';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import theme from 'theme/theme';
import media from 'utils/MediaQueries';
import Button from 'components/Button/Button';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

const Wrapper = styled.div`
	max-width: 1200px;
	width: 100%;
	padding: 10px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const MenuWrapper = styled.div`
	width: 100%;
	padding: 10px 20px;
	justify-content: space-between;
	align-items: center;
	display: none;

	${media.tablet`
		display: ${(props) => props.open && 'flex'};
		padding: ${(props) => props.open && '10px 0'};
	`};
`;

const LinkContainer = styled.div`
	width: 400px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	${media.tablet`
		/* Fixed rather than absolute, and translated rather than offset with
		   'left'. An absolutely-positioned drawer parked at left:100% still
		   counts toward the document's scrollable width, which made every
		   page scroll sideways by exactly one viewport on mobile. A fixed
		   element sits in the viewport's coordinate space and contributes
		   no scroll width — and it also keeps the 100vh drawer pinned
		   instead of scrolling away with the page. */
		position: fixed;
		flex-direction: column;
		justify-content: flex-start;
		width: 100%;
		background-color: white;
		box-sizing: border-box;
		left: 0;
		top: 0;
		height: 100vh;
		z-index: 10;
		padding: 0 20px;
		overflow-y: auto;
		transform: translateX(${(props) => (props.open ? '0' : '100%')});
		/* Visibility flips instantly on open, but waits for the slide-out to
		   finish on close, so the drawer is properly hidden from assistive
		   tech and keyboard focus while closed. */
		visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
		transition: transform 0.2s ease-in,
			visibility 0s linear ${(props) => (props.open ? '0s' : '0.2s')};

		@media (prefers-reduced-motion: reduce) {
			transition: none;
		}
	`};
`;

const Link = styled.a`
	cursor: pointer;
	color: ${(props) => props.active && 'white'};
	text-decoration: ${(props) => props.active && 'underline'};

	&:hover {
		color: white;
	}

	${media.tablet`
		width: 100%;
		padding: 15px 0;
		color: ${(props) => (props.active ? theme.primary1 : theme.background3)};
		font-size: 20px;
		text-decoration: none;

		&:hover {
			color: ${theme.primary1};
		}
	`};
`;

const Image = styled.img`
	cursor: pointer;
`;

const MenuImage = styled.img`
	cursor: pointer;
	width: 154px;
	display: none;

	${media.tablet`
		display: ${(props) => props.open && 'inline-block'};
	`};
`;

const StyledMenuIcon = styled(MenuRoundedIcon)`
	fill: ${theme.text1} !important;
	cursor: pointer !important;
	display: none !important;
	font-size: 40px !important;

	${media.tablet`
		display: inline-block !important;
	`};
`;

const StyledCloseIcon = styled(CloseRoundedIcon)`
	fill: ${theme.background3} !important;
	cursor: pointer !important;
	font-size: 40px !important;
	display: none !important;

	${media.tablet`
		display: ${(props) => props.open && 'inline-block !important'};
	`};
`;

const StyledButton = styled(Button)`
	transition: all 0.2s ease-in;
	${media.tablet`
		padding: ${(props) => props.open && '20px 0'};
		font-size: ${(props) => props.open && '20px'};
		margin-top: ${(props) => props.open && '20px'};
		width: ${(props) => props.open && '100%'};
	`};
`;

export {
	Wrapper,
	LinkContainer,
	Link,
	Image,
	StyledMenuIcon,
	StyledButton,
	MenuImage,
	StyledCloseIcon,
	MenuWrapper,
};
